import Add from '@material-ui/icons/Add'
import { MenuItem, styled } from 'opensolar-ui'
import { useInput } from 'ra-core'
import { TextInputProps } from 'ra-ui-materialui/src/input/TextInput'
import { useMemo, useState } from 'react'
import { AutocompleteSuggestionList, TextInput } from 'react-admin'

const PERSONAL_EMAIL_DOMAINS = ['@gmail.com', '@hotmail.com', '@yahoo.com', '@outlook.com']
interface DomainPredictionEmailInputProps extends TextInputProps {
  mailServerSource: string | typeof PERSONAL_EMAIL_DOMAINS[number]
}

export const DomainPredictionEmailInput: React.FC<DomainPredictionEmailInputProps> = ({
  mailServerSource = '',
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const {
    input: { onChange, value = '' },
  } = useInput({
    type: 'email',
    source: rest.source,
  })

  const inputId = `search__${rest.id || rest.source}`

  const suggestion = useMemo((): string => {
    const suggestedMailServer = '@' + (mailServerSource.match(/@(.+)$/)?.[1] || '')
    const [username = value, typedMailServer = '@'] = value.split('@')
    const suggestedFullEmail = username + suggestedMailServer
    const isPersonalEmail = PERSONAL_EMAIL_DOMAINS.includes(suggestedMailServer)

    const isShowSuggestion =
      !isPersonalEmail && suggestedMailServer.indexOf(typedMailServer) !== -1 && suggestedFullEmail !== value

    if (isShowSuggestion && value) {
      setAnchorEl(document.getElementById(inputId))
      return suggestedFullEmail
    } else {
      setAnchorEl(null)
      return value
    }
  }, [mailServerSource, value, inputId])

  const acceptSuggestion = () => {
    onChange(suggestion)
    setAnchorEl(null)
  }

  return (
    <>
      <TextInput
        {...rest}
        inputProps={{
          autocomplete: 'new-password',
          form: {
            autocomplete: 'new-password',
          },
        }}
        id={inputId}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            acceptSuggestion()
          }
        }}
      />
      {anchorEl && (
        <AutocompleteSuggestionList
          PaperStyle={{ marginTop: 0 }}
          isOpen={Boolean(suggestion)}
          inputEl={anchorEl}
          menuProps={undefined}
        >
          <MenuItem onClick={acceptSuggestion}>
            <StyledAdd />
            {suggestion}
          </MenuItem>
        </AutocompleteSuggestionList>
      )}
    </>
  )
}

const StyledAdd = styled(Add)({
  marginRight: 4,
  marginTop: 3,
})
